var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgChevronDown = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9.51,
    height: 5.122,
    viewBox: "0 0 9.51 5.122",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "chevron-down",
    d: "M1.607,4.607a.366.366,0,0,1,.518,0l4.13,4.131,4.13-4.131a.366.366,0,0,1,.518.518L6.513,9.513a.366.366,0,0,1-.518,0L1.607,5.124a.366.366,0,0,1,0-.518Z",
    transform: "translate(-1.499 -4.499)"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgChevronDown);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI5LjUxIiBoZWlnaHQ9IjUuMTIyIiB2aWV3Qm94PSIwIDAgOS41MSA1LjEyMiI+CiAgPHBhdGggaWQ9ImNoZXZyb24tZG93biIgZD0iTTEuNjA3LDQuNjA3YS4zNjYuMzY2LDAsMCwxLC41MTgsMGw0LjEzLDQuMTMxLDQuMTMtNC4xMzFhLjM2Ni4zNjYsMCwwLDEsLjUxOC41MThMNi41MTMsOS41MTNhLjM2Ni4zNjYsMCwwLDEtLjUxOCwwTDEuNjA3LDUuMTI0YS4zNjYuMzY2LDAsMCwxLDAtLjUxOFoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0xLjQ5OSAtNC40OTkpIi8+Cjwvc3ZnPgo=";